import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { AlertTitle, Button } from '@montugroup/design-system';
import { StyledAlert } from './ClassicCard.styles';
const variantMap = {
    info: {
        severity: 'info',
    },
    success: {
        severity: 'success',
    },
    error: {
        severity: 'error',
    },
    warning: {
        severity: 'warning',
    },
    consult: {
        severity: 'info',
        icon: '🩺',
    },
    shipping: {
        severity: undefined,
        icon: '🚚',
        bgcolor: '#F2EFE4',
    },
    survey: {
        severity: undefined,
        icon: '👋',
        bgcolor: '#F2EFE4',
    },
};
export function ClassicCard({ card, isTopBanner, handleClick, }) {
    const variant = card?.extras?.variant?.toLowerCase();
    const maskContentCard = card?.extras?.dd_mask === 'true';
    const alertProps = variantMap[variant];
    if (!alertProps) {
        return null;
    }
    const alertAction = (() => {
        if (card?.linkText && card?.url) {
            return (_jsx(Button, { href: card?.url, onClick: handleClick, variant: "text", children: card?.linkText }));
        }
        return null;
    })();
    return (_jsxs(StyledAlert, { ...alertProps, isTopBanner: isTopBanner, variant: "standard", action: alertAction, bgColor: alertProps.bgcolor, "data-testid": "classic-card", "data-dd-privacy": maskContentCard ? 'mask' : 'allow', children: [_jsx(AlertTitle, { children: card?.title }), card?.description] }));
}
//# sourceMappingURL=data:application/json;base64,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